import { useTranslation } from "react-i18next";
import singleMode from "./filterBaseSingle";
import collatorSort from "utils/collatorSort";

const rawItems = [
	{ key: 1, code: "69" },
	{ key: 2, code: "bdsm" },
	{ key: 3, code: "bisexual" },
	{ key: 4, code: "bukkake" },
	{ key: 5, code: "creampie" },
	{ key: 6, code: "domination" },
	{ key: 7, code: "fetishes" },
	{ key: 8, code: "fisting" },
	{ key: 9, code: "gang-bang" },
	{ key: 10, code: "deep-throat" },
	{ key: 11, code: "latex" },
	{ key: 12, code: "massage" },
	{ key: 13, code: "masturbation" },
	{ key: 14, code: "naturism" },
	{ key: 15, code: "hard-sex" },
	{ key: 16, code: "perversions" },
	{ key: 18, code: "swallowing" },
	{ key: 19, code: "rimming" },
	{ key: 20, code: "anal-sex" },
	{ key: 21, code: "group-sex" },
	{ key: 22, code: "classic-sex" },
	{ key: 23, code: "oral-sex" },
	{ key: 24, code: "sex-in-unusual-places" },
	{ key: 25, code: "spanking" },
	{ key: 26, code: "squirting" },
	{ key: 27, code: "striptease" },
	{ key: 28, code: "swingers" },
	{ key: 29, code: "threesome-1w-2m" },
	{ key: 30, code: "threesome-1m-2w" },
	{ key: 31, code: "submissiveness" },
	{ key: 32, code: "toys" },
	{ key: 33, code: "face-fucking" },
	{ key: 34, code: "high-heels" },
	{ key: 35, code: "pregnancy" },
	{ key: 36, code: "cuckold" },
	{ key: 37, code: "experiments" },
	{ key: 38, code: "carres" },
	{ key: 39, code: "kisses" },
	{ key: 40, code: "piercing" },
	{ key: 41, code: "orgies" },
	{ key: 42, code: "sexy-lingerie" },
	{ key: 43, code: "stockings" },
	{ key: 44, code: "tights" },
	{ key: 45, code: "thong" },
	{ key: 46, code: "strapon-sex" },
	{ key: 47, code: "sex-in-the-car" },
	{ key: 48, code: "bondage" },
	{ key: 55, code: "exhibitionism" },
	{ key: 60, code: "homosexual" },
	{ key: 61, code: "heterosexual" },
	{ key: 62, code: "conversation" },
	{ key: 63, code: "scratching" },
	{ key: 64, code: "biting" },
	{ key: 65, code: "handcuffs" },
	{ key: 66, code: "interracial" },
	{ key: 67, code: "haired" },
	{ key: 68, code: "depilation" },
	{ key: 69, code: "virginity" },
	{ key: 70, code: "photography" },
	{ key: 71, code: "fake-nails" },
	{ key: 72, code: "short-skirts" },
	{ key: 75, code: "bodystocking" },
	{ key: 76, code: "cunnilingus" },
	{ key: 77, code: "sneakers" },
	{ key: 78, code: "balls-licking" },
	{ key: 79, code: "silicone-breast" },
	{ key: 80, code: "footjob" },
	{ key: 81, code: "handjob" },
	{ key: 82, code: "facesitting" },
	{ key: 83, code: "crossdressing" },
	{ key: 84, code: "tattoos" },
	{ key: 85, code: "selfsucking" },
	{ key: 86, code: "choking" },
	{ key: 87, code: "big-breasts" },
	{ key: 88, code: "big-penis" },
	{ key: 89, code: "peeping" },
	{ key: 90, code: "cuckquean" },
	{ key: 91, code: "bbw" },
	{ key: 92, code: "small-penis" },
	{ key: 93, code: "small-breasts" },
	{ key: 94, code: "feet" },
	{ key: 95, code: "cosplay" },
	{ key: 96, code: "double-penetration" },
	{ key: 97, code: "ddlg" },
	{ key: 98, code: "ddlb" },
	{ key: 99, code: "mdlg" },
	{ key: 100, code: "mdlb" },
	{ key: 101, code: "pegging" },
	{ key: 103, code: "sapiosexual" },
	{ key: 104, code: "metrosexual" },
	{ key: 105, code: "beard" },
	{ key: 106, code: "muscles" },
	{ key: 107, code: "circumcised-penis" },
	{ key: 108, code: "soft-sex" },
	{ key: 109, code: "pole-dance" },
	{ key: 110, code: "foreplay" },
	{ key: 111, code: "big-ass" },
	{ key: 112, code: "ballbusting" },
	{ key: 113, code: "sex-party" },
	{ key: 114, code: "recording-videos" },
	{ key: 115, code: "moustache" },
	{ key: 116, code: "blindfolding" },
	{ key: 117, code: "nymphomania" },
	{ key: 118, code: "unusual-positions" },
	{ key: 119, code: "tantric-sex" },
	{ key: 120, code: "age-difference" },
	{ key: 121, code: "spanish-sex" },
	{ key: 122, code: "harsh-words" },
	{ key: 123, code: "role-playing" },
	{ key: 124, code: "hair-pulling" },
	{ key: 125, code: "petting" },
	{ key: 126, code: "prostate-massage" },
	{ key: 127, code: "shared-bath" },
	{ key: 128, code: "love" },
	{ key: 129, code: "cyber-sex" },
	{ key: 130, code: "sexting" },
	{ key: 131, code: "affair" },
	{ key: 132, code: "flirt" },
	{ key: 133, code: "discretion" },
	{ key: 134, code: "friendship" },
	{ key: 135, code: "joint-trips" },
	{ key: 137, code: "events" },
	{ key: 138, code: "video-calls" },
	{ key: 139, code: "asexuality" },
	{ key: 140, code: "monogamy" },
	{ key: 141, code: "polyamory" },
	{ key: 142, code: "hugging" },
	{ key: 143, code: "tickling" },
];

export { rawItems };

export const isValidInQuery = (value) => {
	if (value === "") {
		return true;
	}
	const validValuesArray = rawItems.map((item) => item.key);
	const valueAsNumber = Number(value);

	return (
		Number.isInteger(valueAsNumber) &&
		validValuesArray.includes(valueAsNumber)
	);
};

export const isValidInParam = (value) => {
	if (value === "" || value === undefined || value === null) {
		return true;
	}
	const validValuesArray = rawItems.map((item) => item.code);

	return validValuesArray.includes(value);
};

export const compute = {
	valueToApiParam: (value) => {
		const current = rawItems.find((item) => item.value === value);
		return current ? current.value : null;
	},
	urlToApiParam: (value) => {
		if (!value) return null;
		const current = rawItems.find(({ code }) => code === value)?.key;
		return Number(current);
	},
	queryUrlToApiParam: (queryUrl) => {
		if (!queryUrl) return null;
		const current = rawItems.find(
			({ key }) => key === Number(queryUrl)
		)?.key;
		return Number(current) ?? null;
	},
	valueToUrl: (value) => {
		const current = rawItems.find(({ key }) => key === value)?.code;
		return current ?? "";
	},
	valueToQueryUrl: (value) => {
		const current = rawItems.find(({ key }) => key === Number(value))?.key;
		return current ?? "";
	},
	urlToValue: (url) => {
		const current = rawItems.find(({ code }) => code === url)?.key;
		return current ?? null;
	},
	queryUrlToValue: (queryUrl) => {
		const current = rawItems.find(
			({ key }) => key === Number(queryUrl)
		)?.key;
		return current ?? null;
	},
	queryUrlToUrl: (queryUrl) => {
		const current = rawItems.find(
			({ key }) => key === Number(queryUrl)
		)?.code;
		return current ?? "";
	},
};

const useFilterPreferences = ({ initial }) => {
	const { t } = useTranslation(["filtersAndSelectors"]);

	const items = rawItems.map((item) => ({
		content: t(`filtersAndSelectors:preferences.${item.key}`),
		value: item.key,
		selected: !(initial === item.key),
		meta: {
			url: item.code,
			value: item.key,
		},
	}));

	const sortedItems = collatorSort(
		collatorSort(items, "content"),
		"selected"
	);

	return {
		rawItems,
		items: sortedItems,
		compute,
		isValidInQuery,
		...singleMode({ items: sortedItems, initial, compute }),
	};
};

export default useFilterPreferences;
